import styled from 'styled-components';
import { Inline } from '@doordash/design-language';

var TimeWrapper = styled.div.withConfig({
  displayName: "Time__TimeWrapper",
  componentId: "sc-1evga9k-0"
})(["display:flex;align-items:center;> *{flex:1 1 100%;min-width:76px;}"]);
var TimeSeparatorContainer = styled(Inline).withConfig({
  displayName: "Time__TimeSeparatorContainer",
  componentId: "sc-1evga9k-1"
})(["flex:0 1 auto;min-width:auto;"]);

export { TimeSeparatorContainer, TimeWrapper };
